/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const ComponentItemFilterMode = createEnum('ITEMS_AND_COMPONENTS_FINDER', {
  Items: '1',
  Components: '2',
  All: '3',
  Fee: '4',
});

export type ComponentItemFilterMode = EnumSet<typeof ComponentItemFilterMode>;
